import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-359a4286")
const _hoisted_1 = { class: "add-resource-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("种植品种")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("地区")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("面积")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "亩", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("上市时间")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("供应周期")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "天", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("预计产量")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "斤", -1)
const _hoisted_11 = { class: "cup-line" }
const _hoisted_12 = { class: "cup-line" }
const _hoisted_13 = { class: "pop-btn" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 提 交 ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_image_form = _resolveComponent("image-form")!
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_video_form = _resolveComponent("video-form")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_cascader = _resolveComponent("van-cascader")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_form, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell_group, { inset: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              "is-link": "",
              readonly: "",
              modelValue: _ctx.varietyData.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.varietyData.name = $event)),
              onClick: _ctx.onSelectVariety,
              name: "variety",
              placeholder: "选择品种",
              rules: [
            {
              required: true,
              trigger: 'onBlur',
              message: '请选择品种',
            },
          ]
            }, {
              label: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["modelValue", "onClick"]),
            _createVNode(_component_van_field, {
              readonly: "",
              modelValue: _ctx.address,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.address = $event)),
              onClick: _ctx.onSelectVariety,
              name: "address",
              "right-icon": "location-o",
              placeholder: "选择省/市/区",
              rules: [
            {
              required: true,
              trigger: 'onBlur',
              message: '请选择地区',
            },
          ]
            }, {
              label: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["modelValue", "onClick"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.detail,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.detail = $event)),
              name: "detail",
              label: "详细地址",
              placeholder: "乡镇村等信息"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.area,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.area = $event)),
              name: "area",
              type: "number",
              placeholder: "请输入",
              rules: [
            {
              required: true,
              trigger: 'onBlur',
              message: '请输入面积',
            },
          ]
            }, {
              label: _withCtx(() => [
                _hoisted_4
              ]),
              "right-icon": _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              "is-link": "",
              readonly: "",
              modelValue: _ctx.selectedDate,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedDate = $event)),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDateDialog = true)),
              name: "date",
              placeholder: "选择日期MM-DD",
              rules: [
            {
              required: true,
              trigger: 'onBlur',
              message: '请选择上市时间',
            },
          ]
            }, {
              label: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.period,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.period = $event)),
              name: "period",
              type: "number",
              placeholder: "请输入",
              rules: [
            {
              required: true,
              trigger: 'onBlur',
              message: '请输入周期',
            },
          ]
            }, {
              label: _withCtx(() => [
                _hoisted_7
              ]),
              "right-icon": _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.yieldNumber,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.yieldNumber = $event)),
              name: "yieldNumber",
              type: "number",
              placeholder: "请输入",
              rules: [
            {
              required: true,
              trigger: 'onBlur',
              message: '请输入产量',
            },
          ]
            }, {
              label: _withCtx(() => [
                _hoisted_9
              ]),
              "right-icon": _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_image_form, { onClick: _ctx.onImage }, null, 8, ["onClick"]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_van_divider)
            ]),
            _createVNode(_component_video_form, { onClick: _ctx.onVideo }, null, 8, ["onClick"]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_van_divider)
            ]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.message,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.message = $event)),
              rows: "3",
              autosize: "",
              label: "备注",
              type: "textarea",
              placeholder: "请输入"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_van_popup, {
      show: _ctx.addResourceDialog,
      "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => (_ctx.addResourceDialog = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cascader, {
          modelValue: _ctx.selectedVariety,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectedVariety = $event)),
          title: "选择品种",
          options: _ctx.varietyOptions,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addResourceDialog = false)),
          onChange: _ctx.varietyChange,
          "field-names": { text: 'name', value: 'id', children: 'values' }
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showDateDialog,
      "onUpdate:show": _cache[14] || (_cache[14] = ($event: any) => (_ctx.showDateDialog = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          modelValue: _ctx.selectedMD,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedMD = $event)),
          onCancel: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showDateDialog = false)),
          onConfirm: _ctx.confirmDate,
          type: "month-day",
          title: "选择月日",
          formatter: 
          function (type, val) {
            if (type === 'month') {
              return `${val}月`;
            }
            if (type === 'day') {
              return `${val}日`;
            }
            return val;
          }
        
        }, null, 8, ["modelValue", "onConfirm", "formatter"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}